//own imports
import './CreateEditGroup.css';
//imports react
import React, {
    useEffect,
    useState
} from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import {
    useParams
} from "react-router-dom";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

//firebase imports
import { collection,  doc, getDoc, addDoc, Timestamp,  updateDoc } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";

import { getAuth, onAuthStateChanged } from "firebase/auth";

const db = getFirestore();
const auth = getAuth();

const CreateEditGroup = () => {

    //parameter
    const {groupId} = useParams();

    const [currentUser, setCurrentUser] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [color, setColor] = useState("seagreen");
    const [groupIdSet, setGroupIdSet] = useState(false);
    const [groupName, setGroupName] = useState("");
    const [groupOwner, setGroupOwner] = useState("");

    //Page title
    useEffect(() => {
        document.title = 'Create Group';

        onAuthStateChanged(auth, (user) => {
            if (user !== null) {
                setCurrentUser(user);
            }
        });

        getCurrentUser();

        if (groupId !== "null") {
            setGroupIdSet(true);
            loadCurrentGroup();
        }
        else {
            setGroupIdSet(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    if (groupIdSet) {
        document.title = 'Edit Group';
        return (
            <div style={{ minHeight: '100vh' }}>
                <h1 className="header">Edit Group</h1>
                <div className="fromBox">
                    <form className="createGroupForm">
                        <label className="label" htmlFor="groupName">Name</label>
                        <input onInput={formValidation} className="inputField groupName" type="text" name="groupName" /><br />
                        <label className="label" htmlFor="desc">Description</label>
                        <textarea className="groupDesc inputField" type="number" name="desc" /> <br />
                        <label className="label" htmlFor="color">Color</label> <br /> <br />
                        <Dropdown options={ddColorOptions} onChange={changeColor} placeholder={"Green"} className="inputField ddCreateGroup"></Dropdown>
                        <span className="errorMessage"></span>
                    </form>
                </div>
                <button className="btn-primary btnAddGroup" onClick={() => editGroup(currentUser.uid, document.getElementsByClassName('groupName')[0].value, document.getElementsByClassName('groupDesc')[0].value, color)}>Update Group</button>
                <Popup trigger={<button className="btn-danger" >Delete Group</button>} position="center" modal>
                   {close => (
                        <div className="popUpDeleteGroup">
                            <div className="popUpDeleteGroup_header"> Delete Group: {groupName}</div>
                            <div className="popUpDeleteGroup_content">Are you sure to delete this group?</div>
                            <p className='errorMessage erroDeleteGroupMessage'></p>
                            <div className="popUpDeleteGroup_actions">
                                <button className="btn-secondary btnCancel" onClick={() => { close(); }}>Cancel</button>
                                <button className="btn-danger" onClick={deleteGroup}>Delete Group</button>
                            </div>
                        </div>
                   )}
                </Popup>
                <button className="btn-secondary btnCancel" onClick={cancel}>Cancel</button>
            </div>
        );
    }
    else {
        return (
            <div style={{ minHeight: '100vh' }}>
                <h1 className="header">Create Group</h1>
                <div className="fromBox">
                    <form className="createGroupForm">
                        <label className="label" htmlFor="groupName">Name</label>
                        <input onInput={formValidation} className="inputField groupName" type="text" name="groupName" /><br />
                        <label className="label" htmlFor="desc">Description</label>
                        <textarea className="groupDesc inputField" type="number" name="desc" /> <br />
                        <label className="label" htmlFor="color">Color</label> <br /> <br />
                        <Dropdown options={ddColorOptions} onChange={changeColor} placeholder={"Green"} className="inputField ddCreateGroup"></Dropdown>
                        <span className="errorMessage"></span>
                    </form>
                </div>
                <button disabled={disabled} style={{ filter: 'grayscale(1)' }} className="btn-primary btnAddGroup" onClick={() => addGroup(currentUser.uid, document.getElementsByClassName('groupName')[0].value, document.getElementsByClassName('groupDesc')[0].value, color)}>Add Group</button>
                <button className="btn-secondary btnCancel" onClick={cancel}>Cancel</button>
            </div>
        );
    }

    async function deleteGroup(){

        goToGroups();

        async function writingToDB(_callback) {
            try {

              if (groupOwner === currentUser.uid) {
                  await updateDoc(doc(db, "Groups", groupId), {
                      isDeleted: true,
                  });
              }
              else{
                  document.getElementsByClassName('erroDeleteGroupMessage')[0].innerHTML = "You can't delete this group, no permissions";
                  return;
              }




            } catch (e) {

                document.getElementsByClassName('erroDeleteGroupMessage')[0].innerHTML = "Error while trying to delete group: " + e.message;
                return;

            }
            _callback();
        }

        function goToGroups() {
            writingToDB(function () {
                window.location.href = "/groups";
            })
        }
    }

    function editGroup(uid, groupName, description, color) {

        const errorMessage = document.getElementsByClassName('errorMessage')[0];

        if (currentUser !== undefined) {
            goToGroups();

            async function writingToDB(_callback) {
                try {
                    await updateDoc(doc(db, "Groups", groupId), {
                        name: groupName,
                        color: color,
                        description: description,
                    });
                } catch (e) {
                    errorMessage.innerHTML = "Error updating document: "+ e;
                }
                _callback();
            }

            function goToGroups() {
                writingToDB(function () {
                    window.location.href = "/groups";
                })
            }
        }
        else {
            errorMessage.innerHTML = 'couldn \'t retrieve current user.';
        }
    }

    async function loadCurrentGroup(){

        const errorMessage = document.getElementsByClassName('errorMessage')[0];

       try {
           const q = doc(db, "Groups", groupId);

           const docSnap = await getDoc(q);
           if (docSnap.exists()) {
               // doc.data() is never undefined for query doc snapshots
               document.getElementsByClassName('groupName')[0].value = docSnap.data().name;
               document.getElementsByClassName('groupDesc')[0].value = docSnap.data().description;
               ddColorOptions.forEach(function (item) {
                   if (item.value === docSnap.data().color) {
                       document.getElementsByClassName('Dropdown-placeholder')[0].innerHTML = item.label;
                   }
               });
               setColor(docSnap.data().color);
               setGroupName(docSnap.data().name);
               setGroupOwner(docSnap.data().owner);

           } else {
               // doc.data() will be undefined in this case
               errorMessage.innerHTML = "No group found! Try again ";
           }
        //krijg alle expenses van de group met bepaald groupId
       } catch (error) {
           errorMessage.innerHTML = "Error getting document: "+ error;
       }
    }

    function formValidation() {
        const groupNameInput = document.getElementsByClassName('groupName')[0];
        const erroMessage = document.getElementsByClassName('errorMessage')[0];
        const btnAddGroup = document.getElementsByClassName('btnAddGroup')[0];
        if (groupNameInput.value == null || groupNameInput.value === "") {
            setDisabled(true);
            erroMessage.style.color = 'red';
            erroMessage.innerHTML = 'Please provide a name for your group.';
            groupNameInput.style.border = '1px solid red';
            btnAddGroup.style.filter = 'grayscale(1)';
        }
        else{
            setDisabled(false);
            erroMessage.innerHTML = '';
            groupNameInput.style.border = '2px solid lightslategray';
            btnAddGroup.style.filter = 'grayscale(0)';
        }
    };

    function changeColor(option) {
        //setting the color
        setColor(option.value);
    }

    function getCurrentUser() {
        if (auth.currentUser !== null) {
            setCurrentUser(auth.currentUser);
        }
    }

    function addGroup(uid, groupName, description, color) {

        const errorMessage = document.getElementsByClassName('errorMessage')[0];

        if(currentUser !== undefined){
            goToGroups();

            async function writingToDB(_callback) {
                try {
                    const docRefGroup = await addDoc(collection(db, "Groups"), {
                        name: groupName,
                        color: color,
                        description: description,
                        owner: uid,
                        expenses: [],
                        admins: [uid],
                        members: [uid],
                        categories: [],
                        isDeleted: false,
                    });

                    addDoc(collection(db, "Groups", docRefGroup.id, "Members"), {
                        uid: uid,
                        membership: Timestamp.fromDate(new Date("1/1/2200")),
                        enteredGroup: Timestamp.now(),
                        permissions: [{ AddRemoveMemersFromGroup: true, EditRemoveGroup: true, EditOthersPermissions: true, CreateRemoveGroupCategories: true, EditRemoveOtherTheirExpenses: true }]
                    });
                } catch (e) {
                    errorMessage.innerHTML = "Error adding document: "+ e;
                }
                _callback();
            }

            function goToGroups() {
                writingToDB(function () {
                    window.history.go(-1);               //geeft een probleem in de hosting.
                })
            }
        }
        else{
            errorMessage.innerHTML = 'couldn \'t retrieve current user.';
        }
    };

    function cancel() {
        window.history.go(-1);
    };
};

const ddColorOptions = [
    { value: 'red', label: 'Red' },
    { value: 'seagreen', label: 'Green' },
    { value: 'royalblue', label: 'Blue' },
    { value: 'darkolivegreen', label: 'Dark Green' },
    { value: 'black', label: 'Black' },
    { value: 'darkslategray', label: 'Gray' },
    { value: 'purple', label: 'Purple' },
    { value: 'darkorange', label: 'Orange' }
]

export default CreateEditGroup;